<template>
  <div class="MultipleChoice">

    <img class="MultipleChoice-image" :src="content.image" />

    <p class="MultipleChoice-question"
      v-if="content.text"
      v-html="replaceName(content.text)">
    </p>

    <div class="MultipleChoice-options"
      v-if="content.options">

      <button-component class="MultipleChoice-option"
        v-for="(option, index) in content.options"
        :key="index"
        @click.native="submit">
        {{ option.label }}
      </button-component>

    </div>

  </div>
</template>

<script>
import ButtonComponent from 'components/Button'

export default {
  name: 'MultipleChoice',

  components: {
    ButtonComponent
  },

  props: {
    content: {
      type: Object,
      required: true
    }
  },

  computed: {
    animal () { return this.$store.state.animal }
  },

  methods: {
    /**
     * Handle button clicks
     */
    submit () {
      this.$store.dispatch('nextLearnPage')
    },

    /**
     * Replace #name# template
     * @param  {String} text
     * @return {String}
     */
    replaceName (text) {
      return text.replace('[name]', this.animal.name, text)
    }
  }
}
</script>

<style>
.MultipleChoice {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 652px;
  text-align: center;
}

.MultipleChoice-image {
  display: block;
  margin-top: 2rem;
  max-height: 231px;
}

.MultipleChoice-question {

}

.MultipleChoice-options {
  margin-top: 50px;
  max-width: 70%;
}

.MultipleChoice-option {
  max-width: 50%;
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// MultipleChoice.vue?f3f7d0ce